import * as React from 'react';
import { CheckboxButton } from '@cian/ui-kit';

import { newbuildingClassDescriptor } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { Container } from '../../components/Container';
import { SIZE_8 } from '../../constants/sizes';
import { getEventValue } from '@cian/newbuilding-utils';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';

export interface INewbuildingClassProps extends IDescriptorProps<string> {
  getOffersCount(): void;
}
export class NewbuildingClassComponent extends React.PureComponent<INewbuildingClassProps> {
  public onChange = (event: React.SyntheticEvent) => {
    const { actionCreator, getOffersCount, descriptors } = this.props;
    const value = getEventValue(event);

    // убрали правило из конвенции и из tslint-config(https://cianru.atlassian.net/browse/CD-33534),
    // но забыли про test-utils, по этому пока  пишем с исключениями
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    actionCreator(descriptors.find(d => d.state === value)!)();
    getOffersCount();
  };

  public render() {
    const { jsonQuery, descriptors } = this.props;
    const activeDescriptors = descriptors.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery));
    const activeDescriptorsMap: { [item: string]: boolean } = {};

    activeDescriptors.forEach(d => {
      activeDescriptorsMap[d.state] = true;
    });

    return (
      <Container display="flex">
        {descriptors.map(({ state, label }) => (
          <Container key={label} margin={`0 ${SIZE_8} 0 0`}>
            <CheckboxButton
              label={label}
              value={state}
              onChange={this.onChange}
              checked={activeDescriptorsMap[state]}
            />
          </Container>
        ))}
      </Container>
    );
  }
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
  };
}

export const NewbuildingClass = connectToDescriptors(
  newbuildingClassDescriptor,
  mapDispatchToProps,
)(NewbuildingClassComponent);
